import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import Coupon from '../models/Coupon';

/**
 * The single promotional offer to feature for this student right now, keyed off
 * days-since-photographed. Pass `packageId` to scope it to the pricelist being
 * viewed, so the offer that's shown/auto-applied is one checkout will honor.
 *
 * `studentId` is the school-scoped external id (Student#studentId), which is what
 * the server's for_landing_page filter looks up — NOT the primary key.
 */
export default function useOfferCoupon(studentId, schoolId, packageId) {
  const forLandingPage = packageId != null
    ? [studentId, schoolId, packageId]
    : [studentId, schoolId];

  return useQuery(
    [studentId, schoolId, packageId, QueryKeys.COUPONS, QueryKeys.OFFER_PAGE],
    () => (
      Coupon
        .where({ forLandingPage })
        .selectExtra(['imageUrl'])
        .first()
        .then((res) => res.data)
    ),
    { enabled: !!(studentId && schoolId) },
  );
}
